/* Wood & Wellness — theme scripts */
(function () {
  'use strict';

  /* Keep page content clear of the fixed header */
  function setHeaderOffset() {
    var header = document.querySelector('header.site-header');
    var spacer = document.getElementById('headerSpacer');
    if (!header || !spacer) return;
    spacer.style.height = header.offsetHeight + 'px';
  }

  /* Scroll reveal */
  var revealObserver;
  function initReveal() {
    var selectors = '.section-head, .testimonial, .value-card, .ritual-step, .spec-item, .accordion-item, .authority-visual, .authority-copy, .page-header';
    var els = document.querySelectorAll(selectors);
    if (!('IntersectionObserver' in window)) return;
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
    }
    els.forEach(function (el, i) {
      if (!el.classList.contains('reveal')) {
        el.classList.add('reveal');
        el.style.transitionDelay = (Math.min(i % 4, 3) * 0.08) + 's';
      }
      if (!el.classList.contains('in-view')) revealObserver.observe(el);
    });
  }

  /* Tabs (product page) */
  window.wwSetTab = function (btn, id) {
    var wrap = btn.closest('.tabs-wrap');
    if (!wrap) return;
    wrap.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('active'); });
    wrap.querySelectorAll('.tab-panel').forEach(function (p) { p.classList.remove('active'); });
    btn.classList.add('active');
    var panel = wrap.querySelector('#tab-' + id);
    if (panel) panel.classList.add('active');
  };

  /* FAQ accordion */
  window.wwToggleAccordion = function (btn) {
    var item = btn.closest('.accordion-item');
    var panel = item.querySelector('.accordion-panel');
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.accordion-item').forEach(function (i) {
      i.classList.remove('open');
      var p = i.querySelector('.accordion-panel');
      if (p) p.style.maxHeight = null;
      var t = i.querySelector('.accordion-trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      item.classList.add('open');
      panel.style.maxHeight = panel.scrollHeight + 'px';
      btn.setAttribute('aria-expanded', 'true');
    }
  };

  /* Body-part toggle (method section) */
  window.wwSetBodyView = function (btn, view) {
    var scope = btn.closest('.authority-visual');
    if (!scope) return;
    scope.querySelectorAll('.body-toggle .size-btn').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    var back = scope.querySelector('[data-body-view="Back"]');
    var quads = scope.querySelector('[data-body-view="Quads"]');
    if (back) back.style.display = view === 'Back' ? 'block' : 'none';
    if (quads) quads.style.display = view === 'Quads' ? 'block' : 'none';
  };

  /* Product gallery */
  window.wwSetMedia = function (btn, url) {
    var wrap = btn.closest('.product-media');
    if (!wrap) return;
    var main = wrap.querySelector('.product-media-main img');
    if (main) main.src = url;
    wrap.querySelectorAll('.product-media-thumbs button').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
  };

  /* Testimonial carousels */
  function initCarousel(root) {
    var track = root.querySelector('.testimonials-track');
    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');
    var dotsWrap = root.querySelector('.carousel-dots');
    if (!track || !prevBtn || !nextBtn || !dotsWrap) return;
    var cards = Array.prototype.slice.call(track.children);
    if (!cards.length) return;

    function perView() { return window.innerWidth <= 860 ? 1 : 3; }
    var pv = perView();
    var page = 0;
    var totalPages = Math.ceil(cards.length / pv);

    function buildDots() {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < totalPages; i++) {
        var dot = document.createElement('span');
        if (i === page) dot.classList.add('active');
        dotsWrap.appendChild(dot);
      }
    }
    function update() {
      var cardWidth = cards[0].getBoundingClientRect().width;
      track.scrollLeft = page * pv * (cardWidth + 24);
      prevBtn.disabled = page === 0;
      nextBtn.disabled = page >= totalPages - 1;
      Array.prototype.forEach.call(dotsWrap.children, function (d, i) {
        d.classList.toggle('active', i === page);
      });
    }
    prevBtn.addEventListener('click', function () { if (page > 0) { page--; update(); } });
    nextBtn.addEventListener('click', function () { if (page < totalPages - 1) { page++; update(); } });
    window.addEventListener('resize', function () {
      var np = perView();
      if (np !== pv) { pv = np; totalPages = Math.ceil(cards.length / pv); page = 0; buildDots(); update(); }
    });
    buildDots();
    update();
  }

  function init() {
    setHeaderOffset();
    initReveal();
    document.querySelectorAll('.testimonials-wrap').forEach(initCarousel);
    document.querySelectorAll('.accordion-item.open .accordion-panel').forEach(function (p) {
      p.style.maxHeight = p.scrollHeight + 'px';
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', setHeaderOffset);

  /* Re-init when merchants edit sections in the theme customizer */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', setHeaderOffset);
})();
